import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ContactInformation } from '../../entities/organisation/contact-information.entity';
import { AbstractHttpService } from '../http/http-service.abstract';

@Injectable()
export class OrganisationService {
    private readonly ENDPOINT = 'organisation';

    constructor(private readonly http: AbstractHttpService) {}

    getContactInfo(): Observable<ContactInformation> {
        return this.http.get(`${this.ENDPOINT}/contact-info`);
    }

    saveContactInfo(data: ContactInformation) {
        return this.http.put(`${this.ENDPOINT}/contact-info`, data);
    }
}
